import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link, useParams } from "react-router-dom";


/**
 * PanUploded component displays a success message after PAN card submission.
 * Provides navigation to bank/pancard details page.
 */
const PanUploded = ({ login = null }) => {
  // Use useParams hook to get URL parameters
  const { userId } = useParams();
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  return (
    <>
      <div className="container vh-100 mt-4">
        <div className="row">
          <div className="col-md-6 mt-10 pancard-data">
            <div className="text-center mb-7">
              <img
                width="50%"
                alt="icon"
                src={toAbsoluteUrl("/media/images/new1-success.png")}
              />
            </div>
          </div>

          <div className="col-md-12 mt-3 pancard-data">
            <div className="mt-3">
              <h1 className="mb-5">Success</h1>
              <p>Your PAN Card details have been successfully Submitted</p>
              <div className="mt-2 d-flex justify-content-center ">
                <Link to={`/${redirectUrl}/bankpancard-details/${userId}`}>
                  <button className="btn btn-lg w-200px btn-danger text-white">OK</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PanUploded;
